import React from 'react';

interface ProgressBarProps {
  percent: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => {
  return (
    <div
      css={theme => ({
        background: theme.neutral90,
        height: '4px',
        width: '100%',
      })}
    >
      <div
        css={theme => ({
          background: theme.upsellColor,
          height: '4px',
          width: `${percent}%`,
        })}
      />
    </div>
  );
};
